module.exports = __webpack_public_path__ + "static/media/hearts_5.d9a3800f.png";